import { a as __extends } from '../../../../tslib/tslib.es6-LMiJArAJ-BzgLaGEp.js';
import * as React from 'react';
import { s as shallowEqual, i as invariantIntlContext, D as DEFAULT_INTL_CONFIG } from '../utils-BIG_B-Jx-BNoSNLtk.js';
import { P as Provider } from './injectIntl-BtqeBzQq-DKO65rGD.js';
import { c as createIntl } from './createIntl-CF-rRoPw-DQ8TwHqP.js';
import { a as createIntlCache } from '../../../../_formatjs/intl/lib/src/utils-BY-09i56-ivXiu23M.js';

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
function processIntlConfig(config) {
  return {
    locale: config.locale,
    timeZone: config.timeZone,
    fallbackOnEmptyString: config.fallbackOnEmptyString,
    formats: config.formats,
    textComponent: config.textComponent,
    messages: config.messages,
    defaultLocale: config.defaultLocale,
    defaultFormats: config.defaultFormats,
    onError: config.onError,
    onWarn: config.onWarn,
    wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
    defaultRichTextElements: config.defaultRichTextElements
  };
}
var IntlProvider = /** @class */function (_super) {
  __extends(IntlProvider, _super);
  function IntlProvider() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.cache = createIntlCache();
    _this.state = {
      cache: _this.cache,
      intl: createIntl(processIntlConfig(_this.props), _this.cache),
      prevConfig: processIntlConfig(_this.props)
    };
    return _this;
  }
  IntlProvider.getDerivedStateFromProps = function (props, _a) {
    var prevConfig = _a.prevConfig,
      cache = _a.cache;
    var config = processIntlConfig(props);
    if (!shallowEqual(prevConfig, config)) {
      return {
        intl: createIntl(config, cache),
        prevConfig: config
      };
    }
    return null;
  };
  IntlProvider.prototype.render = function () {
    invariantIntlContext(this.state.intl);
    return /*#__PURE__*/React.createElement(Provider, {
      value: this.state.intl
    }, this.props.children);
  };
  IntlProvider.displayName = 'IntlProvider';
  IntlProvider.defaultProps = DEFAULT_INTL_CONFIG;
  return IntlProvider;
}(React.PureComponent);

export { IntlProvider as I };
//# sourceMappingURL=provider-DxrpHEUT-CDR-Xk4U.js.map
